var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","loading":_vm.loading},on:{"click":_vm.toDownloadPage}},[_c('v-icon',{attrs:{"size":"20px","left":""}},[_vm._v("mdi-download-outline")]),_c('span',{staticClass:"text-capitalize"},[_vm._v("Télécharger")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }